import { render } from "./AdminLoaders.vue?vue&type=template&id=33f7a0aa"
const script = {}

import "./AdminLoaders.vue?vue&type=style&index=0&id=33f7a0aa&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__